import { render, staticRenderFns } from "./MyImage.vue?vue&type=template&id=08b1f3d5&"
import script from "./MyImage.vue?vue&type=script&lang=js&"
export * from "./MyImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/pc/Documents/Programs/Vue/top-ten-naija/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
import { VRow } from 'vuetify/lib'
installComponents(component, {VImg,VProgressCircular,VRow})
